__webpack_require__.p = "/2024/clinic/admin/";